import { gql } from '@apollo/client';

export const ADVANCED_NAMES_SEARCH = gql`
    query SearchNamesAdvanced(
        $operations: [AdvancedSearchOperation!]!
        $size: Int
        $skip: Int
        $sort: SortInput
    ) {
        searchNamesAdvanced(data: {
            operations: $operations
            size: $size
            skip: $skip
            sort: $sort
        }) {
            names {
                nameId
                nameValue
                nameType
                nameInternalComment
                nameIsLegal
                nameIsni
                partyCountryOfOriginName
                nameCreatedBy
                nameCreatedAt
                nameUpdatedBy
                nameUpdatedAt
                partyId
                partyType
                privacyType
            }
            totalCount
        }
    }
`;
